export default function(auth, commit) {
	commit('provider/removePatient', auth)
}
